<template>
  <v-navigation-drawer permanent app class="menu">
    <v-list>
      <v-list-item two-line>
        <v-col>
          <v-row justify="center">
            <router-link class="justify-content-center" :to="homeUrl">
              <img
                :src="require(`@/assets/logos/usecargobranco.png`)"
                alt="pickndrive"
                style="width: 200px"
              />
            </router-link>
          </v-row>
        </v-col>
      </v-list-item>
    </v-list>

    <v-divider color="white"></v-divider>

    <v-list
      v-for="menu in menus"
      :key="menu.route"
      class="transparent white--text"
    >
      <v-list-group v-if="menu.submenu.length > 0">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon class="submenu">{{ menu.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="submenu">{{
              menu.title
            }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item v-for="submenu in menu.submenu" :key="submenu.route">
          <v-list-item-icon>
            <v-icon class="submenu">{{ submenu.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <router-link :to="{ name: submenu.route }">
              <span class="submenu">{{ submenu.title }}</span>
            </router-link>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-item v-else>
        <v-list-item-icon>
          <v-icon class="submenu">{{ menu.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <router-link :to="{ name: menu.route }">
            <span class="submenu">{{ menu.title }}</span>
          </router-link>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-list class="transparent white--text">
      <v-list-item @click="logout()">
        <v-list-item-icon>
          <v-icon class="submenu">mdi-close-circle</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <span class="submenu">Sair</span>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import Menu from './../../models/Menu.js';
import AuthController from './../../controllers/AuthController.js';

export default {
  props: {
    menus: {
      required: true,
      types: [Array, Menu],
    },
    homeUrl: String,
    profileRouter: String,
    helpRouter: String,
  },
  created() {
    this.authController = new AuthController(this.$resource, this.$router);
  },
  data: () => ({}),
  methods: {
    logout() {
      this.authController.logout();
    },
  },
};
</script>
<style lang="scss">
.menu {
  background-color: var(--secondary-color) !important;
  height: 100%;
  overflow: auto;
}

::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-thumb {
  background-color: #b5b9bd;
  border-radius: 5px;
}
::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}

.submenu {
  color: white !important;
}

@media (max-width: 768px) {
  .menu {
    width: 56px !important;
  }
}
</style>
